// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-tsx": function componentSrcPages404Tsx() {
    return import("./../../src/pages/404.tsx"
    /* webpackChunkName: "component---src-pages-404-tsx" */
    );
  },
  "component---src-pages-kiitos-tsx": function componentSrcPagesKiitosTsx() {
    return import("./../../src/pages/kiitos.tsx"
    /* webpackChunkName: "component---src-pages-kiitos-tsx" */
    );
  },
  "component---src-pages-ota-yhteytta-tsx": function componentSrcPagesOtaYhteyttaTsx() {
    return import("./../../src/pages/ota-yhteytta.tsx"
    /* webpackChunkName: "component---src-pages-ota-yhteytta-tsx" */
    );
  },
  "component---src-templates-pages-basic-template-tsx": function componentSrcTemplatesPagesBasicTemplateTsx() {
    return import("./../../src/templates/pages/basicTemplate.tsx"
    /* webpackChunkName: "component---src-templates-pages-basic-template-tsx" */
    );
  },
  "component---src-templates-pages-blog-template-tsx": function componentSrcTemplatesPagesBlogTemplateTsx() {
    return import("./../../src/templates/pages/blogTemplate.tsx"
    /* webpackChunkName: "component---src-templates-pages-blog-template-tsx" */
    );
  },
  "component---src-templates-pages-info-template-tsx": function componentSrcTemplatesPagesInfoTemplateTsx() {
    return import("./../../src/templates/pages/infoTemplate.tsx"
    /* webpackChunkName: "component---src-templates-pages-info-template-tsx" */
    );
  },
  "component---src-templates-pages-normal-template-tsx": function componentSrcTemplatesPagesNormalTemplateTsx() {
    return import("./../../src/templates/pages/normalTemplate.tsx"
    /* webpackChunkName: "component---src-templates-pages-normal-template-tsx" */
    );
  }
};